import { Route } from "@angular/router";
import { languageRedirectGuard } from "./_base/language-redirect.guard";
import { LayoutComponent } from "./layout/layout/layout.component";
import { PublicLayoutComponent } from "./layout/public-layout/public-layout.component";
import { LogoutCallbackComponent } from "./auth/LogoutCallbackComponent";

export default [
  { path: 'logout-callback', component: LogoutCallbackComponent },
  {
    path: ":language/koppeling/goedkeuren/:token",
    component: PublicLayoutComponent,
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./coupling/pages/approve/approve.component").then(
            (m) => m.CouplingApproveComponent
          ),
      },
    ],
  },
  {
    path: ":language/koppeling/weigeren/:token",
    component: PublicLayoutComponent,
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./coupling/pages/reject/reject.component").then(
            (m) => m.CouplingRejectComponent
          ),
      },
    ],
  },
  {
    path: ":language/:orgKey",
    component: LayoutComponent,
    children: [
      {
        path: "person/:accessKey",
        loadChildren: () => import("./person/person-routes"),
        data: {
          breadcrumb: "Mijn persoonsgegevens",
        },
      },
      {
        path: "gebruiker",
        loadChildren: () => import("./user/user-routes"),
        data: {
          breadcrumb: "Mijn Assist-account",
        },
      },
      {
        path: "vrijwilliger/:accessKey",
        loadChildren: () => import("./volunteer/volunteer-routes"),
        data: {
          breadcrumb: "Mijn vrijwilligersgegevens",
        },
      },
      {
        path: "member/:accessKey",
        loadChildren: () => import("./member/member-routes"),
        data: {
          breadcrumb: "Mijn lidmaatschap",
        },
      },
      {
        path: "activity/:accessKey",
        loadChildren: () => import("./activity/activity-routes"),
        data: {
          breadcrumb: "Mijn agenda",
        },
      },
      {
        path: "expenses/:accessKey",
        loadChildren: () => import("./expenses/expenses-routes"),
        data: {
          breadcrumb: "Mijn kosten",
        },
      },
      {
        path: "intrests/:accessKey",
        loadChildren: () => import("./intrests/intrests-routes"),
        data: {
          breadcrumb: "Mijn interesses en talenten",
        },
      },
      {
        path: "tasks/:accessKey",
        loadChildren: () => import("./tasks/tasks-routes"),
        data: {
          breadcrumb: "Mijn taken",
        },
      },
      /*{
        path: 'waitinglist2',
        loadChildren: () => import('./waitinglist/waitinglist-routes'),
        data: {
          breadcrumb: 'Wachtlijst',
        },
      },*/
      {
        path: "waitinglist/:accessKey",
        loadChildren: () => import("./waitinglist-member/waitinglist-member-routes"),
        data: {
          breadcrumb: "Wachtlijst",
        },
      },
    ],
    data: {
      breadcrumb: "MijnAssist",
    },
  },
  {
    path: "",
    component: PublicLayoutComponent,
    children: [
      {
        path: "activity",
        loadChildren: () => import("./activity/activity-routes"),
      },
    ],
  },
  {
    path: ":language/:orgKey",
    component: PublicLayoutComponent,
    children: [
      {
        path: "waitinglist",
        loadChildren: () => import("./waitinglist/waitinglist-routes"),
        data: {
          breadcrumb: "Wachtlijst",
        },
      },
      {
        path: "thank-you",
        loadChildren: () => import("./thank-you/thank-you-routes"),
      },
      {
        path: "form",
        loadChildren: () => import("./forms/forms-routes"),
        data: {
          breadcrumb: "Formulier",
        },
      },
    ],
  },
  {
    path: "temp",
    component: LayoutComponent,
    children: [
      {
        path: "expenses",
        loadChildren: () => import("./expenses/expenses-routes"),
      },
    ],
  },
  {
    path: "**",
    canMatch: [languageRedirectGuard],
    component: PublicLayoutComponent,
  },
] satisfies Route[];
